// src/pages/admin/utils/sectionStyle.js

export const STYLE_DEFAULTS = {
  // background
  bgMode: "default",
  bgColor: "",
  bgGradientFrom: "",
  bgGradientVia: "",
  bgGradientTo: "",
  bgGradientAngle: "135",

  // text + buttons
  titleColor: "",
  subtitleColor: "",
  primaryBtnBg: "",
  primaryBtnText: "",
  secondaryBtnBorder: "",
  secondaryBtnText: "",

  // hero template 1 badge
  heroBadgeBg: "",
  heroBadgeBorder: "",
  heroBadgeTitleColor: "",
  heroBadgeSubtitleColor: "",

  // hero template 2 tag
  heroTagBg: "",
  heroTagBorder: "",
  heroTagTextColor: "",

  // hero template 3 stats
  statsCardBg: "",
  statsCardBorder: "",
  statsValueColor: "",
  statsLabelColor: "",

  // features template 1
  featuresCardBg: "",
  featuresCardBorder: "",
  featuresCardTitleColor: "",
  featuresCardDescriptionColor: "",

  // features template 2
  featuresBadgeBg: "",
  featuresBadgeTextColor: "",
  featuresBadgeBorder: "",
  featuresCardBg2: "",
  featuresCardBorder2: "",
  featuresCardTitleColor2: "",
  featuresCardDescriptionColor2: "",
  featuresBenefitColor2: "",
  featuresBottomCtaBgFrom: "",
  featuresBottomCtaBgTo: "",
  featuresBottomCtaTitleColor: "",
  featuresBottomCtaSubtitleColor: "",

  // features template 3
  featuresTabActiveBg: "",
  featuresTabActiveBorder: "",
  featuresTabInactiveBg: "",
  featuresTabTitleColor: "",
  featuresTabDescriptionColor: "",
  featuresFloatingBadgeBg: "",
  featuresFloatingBadgeTitleColor: "",
  featuresFloatingBadgeSubtitleColor: "",

  // testimonials shared
  testimonialsCardBg: "",
  testimonialsCardBorder: "",
  testimonialsNameColor: "",
  testimonialsRoleColor: "",
  testimonialsContentColor: "",
  testimonialsAvatarBg: "",
  testimonialsAvatarText: "",
  testimonialsStarActiveColor: "",
  testimonialsStarInactiveColor: "",

  // testimonials template 2
  testimonialsQuoteIconColor: "",
  testimonialsMainCardBg: "",
  testimonialsMainCardBorder: "",
  testimonialsCompanyColor: "",
  testimonialsDotActive: "",
  testimonialsDotInactive: "",
  testimonialsNavBtnBg: "",
  testimonialsNavBtnBorder: "",
  testimonialsNavBtnIcon: "",
  testimonialsPreviewCardBg: "",
  testimonialsPreviewCardBorder: "",
  testimonialsPreviewActiveBg: "",
  testimonialsPreviewActiveBorder: "",

  // testimonials template 3
  testimonialsTopIconBg: "",
  testimonialsTopIconColor: "",
  testimonialsMetricBadgeBg: "",
  testimonialsMetricBadgeText: "",
  testimonialsResultBadgeBg: "",
  testimonialsResultBadgeText: "",
  testimonialsAccentBg: "",
  testimonialsAccentText: "",

  // gallery shared
  galleryCardBg: "",
  galleryCardBorder: "",
  galleryCardTitleColor: "",
  galleryCardDescriptionColor: "",
  galleryOverlayColor: "",
  galleryOverlayTextColor: "",
  galleryBadgeBg: "",
  galleryBadgeTextColor: "",
  galleryEmptyStateColor: "",

  // gallery 1
  galleryStatsCardBg: "",
  galleryStatsCardBorder: "",
  galleryStatsValueColor: "",
  galleryStatsLabelColor: "",
  galleryModalBg: "",
  galleryModalTitleColor: "",
  galleryModalCategoryColor: "",
  galleryModalTextColor: "",
  galleryModalFeatureBoxBg: "",
  galleryModalFeatureBoxBorder: "",
  galleryModalFeatureTitleColor: "",
  galleryModalFeatureTextColor: "",
  gallerySecondaryBtnBg: "",
  gallerySecondaryBtnBorder: "",
  gallerySecondaryBtnText: "",

  // gallery 2
  galleryFilterActiveBg: "",
  galleryFilterActiveText: "",
  galleryFilterInactiveBg: "",
  galleryFilterInactiveText: "",
  galleryFilterInactiveBorder: "",

  // gallery 3
  galleryMainTextColor: "",
  galleryResultCardBg: "",
  galleryResultCardBorder: "",
  galleryResultValueColor: "",
  galleryResultLabelColor: "",
  galleryThumbActiveBorder: "",
  galleryThumbOverlayColor: "",
  galleryMoreProjectsLabelColor: "",

  // category shared
  categoryCardBg: "",
  categoryCardBorder: "",
  categoryCardTitleColor: "",
  categoryCardSubtitleColor: "",
  categoryLinkColor: "",
  categoryImageOverlayColor: "",
  categoryFeaturedBadgeBg: "",
  categoryFeaturedBadgeText: "",
  categoryFeaturedBadgeBorder: "",
  categoryFeaturedPanelBg: "",
  categoryFeaturedPanelBorder: "",
  categoryMetricBoxBg: "",
  categoryMetricBoxBorder: "",
  categoryMetricLabelColor: "",
  categoryMetricValueColor: "",

  // location shared
  locationCardBg: "",
  locationCardBorder: "",
  locationPanelBg: "",
  locationPanelBorder: "",
  locationNameColor: "",
  locationTextColor: "",
  locationMutedTextColor: "",
  locationIconColor: "",
  locationBadgeBg: "",
  locationBadgeTextColor: "",
  locationBadgeBorder: "",
  locationMapTabActiveBg: "",
  locationMapTabActiveText: "",
  locationMapTabInactiveBg: "",
  locationMapTabInactiveText: "",
  locationMapTabBorder: "",
  locationImageOverlayColor: "",
  locationTodayBg: "",
  locationTodayText: "",

  // service shared
  serviceCardBg: "",
  serviceCardBorder: "",
  serviceCardTitleColor: "",
  serviceCardDescriptionColor: "",
  serviceIconBg: "",
  serviceIconColor: "",
  serviceBadgeBg: "",
  serviceBadgeTextColor: "",
  serviceBadgeBorder: "",
  serviceFeatureTextColor: "",
  serviceFeatureIconColor: "",
  serviceLinkColor: "",
  serviceMutedTextColor: "",

  // service template 2
  servicePanelBg: "",
  servicePanelBorder: "",
  serviceMetaTextColor: "",
  serviceImageOverlayColor: "",
  serviceNavBtnBg: "",
  serviceNavBtnBorder: "",
  serviceNavBtnIcon: "",
  serviceDotActive: "",
  serviceDotInactive: "",
  servicePriceColor: "",

  // service template 3
  servicePricingToggleBg: "",
  servicePricingToggleActiveBg: "",
  servicePricingToggleActiveText: "",
  servicePricingToggleInactiveText: "",
  servicePopularBadgeBg: "",
  servicePopularBadgeText: "",
  serviceHighlightedRing: "",
  servicePeriodColor: "",
  serviceLimitationsColor: "",
  serviceXIconColor: "",
  serviceSecondaryBtnBg: "",
  serviceSecondaryBtnText: "",
  serviceSecondaryBtnBorder: "",

  // CTA shared
  ctaCardBg: "",
  ctaCardBorder: "",
  ctaPanelBg: "",
  ctaPanelBorder: "",
  ctaInputBg: "",
  ctaInputBorder: "",
  ctaInputText: "",
  ctaInputLabelColor: "",
  ctaMutedTextColor: "",
  ctaSuccessIconBg: "",
  ctaSuccessIconColor: "",
  ctaSuccessTitleColor: "",
  ctaSuccessSubtitleColor: "",
  ctaInfoCardBg: "",
  ctaInfoCardBorder: "",
  ctaInfoTitleColor: "",
  ctaInfoTextColor: "",
  ctaInfoNoteColor: "",
  ctaFooterBarBg: "",
  ctaFooterTextColor: "",
  ctaAccentBg: "",
  ctaAccentText: "",
  ctaAccentBorder: "",
  ctaTabActiveBg: "",
  ctaTabActiveText: "",
  ctaTabInactiveBg: "",
  ctaTabInactiveText: "",
  ctaTabBorder: "",
  ctaBadgeBg: "",
  ctaBadgeText: "",
  ctaBadgeBorder: "",
  ctaQuickItemBg: "",
  ctaQuickItemBorder: "",
  ctaQuickItemText: "",
  ctaMetricCardBg: "",
  ctaMetricCardBorder: "",
  ctaMetricValueColor: "",
  ctaMetricLabelColor: "",
  ctaSecondaryBtnBg: "",
};

export const normalizeStyle = (style) => {
  const merged = { ...STYLE_DEFAULTS, ...(style || {}) };

  const hadBgColorBefore = Boolean(style?.bgColor && String(style.bgColor).trim());
  const hasBgModeBefore = Boolean(style?.bgMode);

  if (!hasBgModeBefore && hadBgColorBefore) merged.bgMode = "solid";
  if (!merged.bgMode) merged.bgMode = "default";

  return merged;
};